import {
    Achievement,
    AchievementRequest,
    AchievementsRequest,
    AchievementResponse,
    AchievementsResponse,
} from '@ai-platform/utils';
import { api, ApiTags } from '../../api';
import { transformAchievementDtoToModel } from './mappers';

const endpoint = '/achievements';

const achievementApi = api.injectEndpoints({
    endpoints: build => ({
        getAchievements: build.query<Achievement[], AchievementsRequest>({
            query: params => ({
                url: endpoint,
                params,
            }),
            transformResponse: (response: AchievementsResponse) => {
                return response.achievements.map(transformAchievementDtoToModel);
            },
            providesTags: [{ type: ApiTags.Achievements, id: 'LIST' }],
        }),
        getAchievement: build.query<Achievement, AchievementRequest>({
            query: ({ id }) => `${endpoint}/${id}`,
            transformResponse: (response: AchievementResponse) => {
                return transformAchievementDtoToModel(response);
            },
            providesTags: (_, __, request) => [{ type: ApiTags.Achievements, id: request.id }],
        }),
    }),
});

export const { useGetAchievementsQuery, useGetAchievementQuery } = achievementApi;
export { achievementApi };
